<ng-container *ngIf="showClassic; else modernTpl">
  <fa-icon
    [icon]="icon"
    [class]="className"
    [style.fontSize.px]="size"
    title="{{ title }}"
  ></fa-icon>
</ng-container>

<ng-template #modernTpl>
  <span
    class="app-icon-svg"
    [class]="className"
    [style.color]="color || null"
    [innerHTML]="svgHtmlSafe"
    title="{{ title }}"
  ></span>
  <!-- Using CSS currentColor inside SVG for fast, flicker-free recoloring -->
</ng-template>
